export default {
    "image": {
        "insert": "Insert Image in",
        "url": "Image URL",
        "alt": "Alt text",
        "tooltip": "Insert image",
        "options":{
            "url": "URL",
            "file":"Insert File"
        },
        "file":"Upload File",
        "preview":"Preview",
        "caption":"Enter Caption...",
        "delete":"Delete image",
    },
    "align": {
        "title": "Align",
        "left": "Left align",
        "center": "Center align",
        "right": "Right align",
        "justify": "Justify",
        "outdent": "Outdent",
        "indent": "Indent"
    },
    "block": {
        "title": "Text block",
        "normal": "Normal",
        "large": "Large heading",
        "small": "Small heading",
        "bullet": "Bullet list",
        "numbered": "Numbered list",
        "quote": "Quote",
        "code": "Code",
        "codeLanguages": "Code languages",
    },
    "format": {
        "title": "Format text",
        "subscript": "Subscript",
        "superscript": "Superscript",
        "underline": "Underline",
        "strikethrough": "Strikethrough",
        "bold": "Bold",
        "italic": "Italic",
        "uppercase":"Uppercase",
        "lowercase":"Lowercase",
        "capitalize":"Capitalize"
    },
    "video":{
        "insert":"Insert Youtube Video in",
        "url": "Youtube Video URL",
    },
    "excalidraw":{
        "discardMessage":"Are you sure you want to discard the changes?",
        "cancel":"Cancel",
        "insert":"Insert",

    },
    "fontSizeOptions":{
        "increaseFontSize":"Increase Font Size",
        "decreaseFontSize":"Decrease Font Size",
    },
    "fontFamily": "Font family",
    "fontSize": "Font size",
    "title": "Rich text",
    "placeholder": "Enter some text...",
    "link": "Insert link",
    "undo": "Undo",
    "redo": "Redo",
    "fontColor": "Font color",
    "backgroundColor": "Highlight color",
    "language":"Current language:",
    "dropdownItems": {
        "insert": "Insert",
        "insertHorizontalLine": "Horizontal Line",
        "insertImage": "Image",
        "collapsibleContainer": "Collapsible Container",
        "excalidraw": "Excalidraw",
        "youtube": "YouTube"
    },
    "richTextCloseConfirmTitle": "Do you want to close the Rich Text Editor?",
    "richTextCloseConfirmWarning": "If you close it, changes will not be saved."
};